import React from 'react';

import gql from 'graphql-tag';
import PropTypes from 'prop-types';
import { Mutation } from 'react-apollo';

import ErrorModal from '../ErrorModal';
import MutationRequest from '../MutationRequest';

export const SNIP_TO_PAGE = gql`
  mutation SkipPage($contentGroupId: Int!, $contentPageId: Int!) {
    contentGroup {
      addAction(
        skipToSnippet: {
          contentGroupId: $contentGroupId
          contentPageId: $contentPageId
        }
      ) {
        id
      }
    }
  }
`;

const SkipToPage = ({
  contentGroupId,
  contentPageId,
  onError,
  onSuccessResult,
}) => (
  <Mutation mutation={SNIP_TO_PAGE}>
    {(SkipPage, { loading, error, data }) => {
      const variables = {
        contentGroupId,
        contentPageId,
      };

      if (error) {
        return <ErrorModal error={error} onError={onError} />;
      }
      if (data) {
        onSuccessResult(data.contentGroup.addAction.id);
      }

      return (
        <MutationRequest
          isLoading={loading}
          mutation={SkipPage}
          variables={variables}
        />
      );
    }}
  </Mutation>
);

SkipToPage.propTypes = {
  contentGroupId: PropTypes.number.isRequired,
  contentPageId: PropTypes.number.isRequired,
  onError: PropTypes.func.isRequired,
  onSuccessResult: PropTypes.func.isRequired,
};

export default SkipToPage;
